import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { Tooltip } from '@components/Tooltip/Tooltip';

const useStyles = makeStyles(() => ({
	procedureName: {
		height: '1.25rem',
		overflow: 'clip',
		textDecoration: 'underline',
		display: 'inline-block',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		maxWidth: '100%',
	},
}));

export const SurgeonEventProcedureToolTip: React.FC<{ title?: string }> = ({ children, title }) => {
	const classes = useStyles();
	return (
		<Tooltip
			data-field="scheduling-eventCard-procedureToolTip"
			title={title || ''}
			placement="top-start"
			arrow
		>
			<Typography
				variant="body2"
				className={classes.procedureName}
			>
				{children}
			</Typography>
		</Tooltip>
	);
};
